export const VIEW_REGISTRATION = "ViewRegistration";
export const PROCESS_REGISTRATION = "ProcessRegistration";
export const VIEW_CUSTOMER_ASSIGNMENT = "ViewCustomerAssignment";
export const CREATE_CUSTOMER = "CreateCustomer";
export const ASSIGN_CUSTOMER = "AssignCustomer";
export const VIEW_RWA_MAPPING = "ViewRWAMapping";
export const CREATE_RWA_MAPPING = "CreateRWAMapping";
export const VIEW_CANCEL_STATUS = "ViewCancelStatus";
export const VIEW_SYSTEM_STATUS = "ViewSystemStatus";
